import { useState, useEffect, useContext } from 'react';
import { Tooltip } from 'react-tooltip';
import CreatableSelect from 'react-select/creatable';

// date imports;
import useGainsQCApi from '../../services/useGainsQCApi';
import { pipelineContext } from '../../contexts/pipelineContext';
import formatDate, { formatDateTime2 } from '../../helpers/formatDate';
import { endpointContext } from '../../contexts/endpointContext';
import { capFirstLetter } from '../qc_steps/helpers';

export const CommentsModal = ({
	user,
	data,
	currentCapture,
	fetchingComments,
	commentType,
	urlString
}) => {

	console.log("commentModal", commentType, data, urlString)

	const [formValid, setFormValid] = useState(false);
	const initialCommentFormValue = {
		subject_id: commentType === 'site' ? currentCapture?.site_id : currentCapture?.id,
		content: {
			text: '',
			attachment: null
		},
		user_id: user,
		created: formatDateTime2(new Date().toISOString()),
		status_id: 1,
		category_id: 1
	};
	const [editingComment, setEditingComment] = useState(null);
	const [commentFormValue, setCommentFormValue] = useState(
		initialCommentFormValue
	);
	const [showDeletedComments, setShowDeletedComments] = useState(false)
	const [selectedLabels, setSelectedLabels] = useState(null);
	const [uploadedFile, setUploadedFile] = useState(null);
	const { comm } = useContext(pipelineContext);
	const commentAPI = useGainsQCApi();
	const getPreSignedUrl = useGainsQCApi();
	const changeCommentStatus = useGainsQCApi();
	const endpointContextObj = useContext(endpointContext);
	const filteredComments = !showDeletedComments
		? data?.filter((comm) => comm.content.text !== '[deleted]')
		: data;

	useEffect(() => {
		checkFormValidity();
	}, [commentFormValue]);

	useEffect(() => {
		if (!user) return;

		setCommentFormValue({ ...commentFormValue, user_id: user });
	}, [user]);

	const changingCommentStatus = async (commentId, newStatusId) => {
		await changeCommentStatus.makeRequest(
			`/${comm}/comments/${urlString}/${commentId}/status`,
			'PATCH',
			{ status_id: newStatusId },
			'new comment status',
			undefined,
			undefined,
			undefined,
			undefined
		);
	};

	const labelsToOptions = (labels = '') =>
		labels
			?.split(',')
			?.map((label) => label.trim())
			?.filter(Boolean)
			?.map((label) => ({
				value: label,
				label
			}));

	const labelsToString = (labels) => {
		if (!labels?.length) return '';

		return labels.map((l) => l.value).join(',');
	};

	const checkFormValidity = () => {
		let valid = true;
		if (commentFormValue.content.text.length === 0) {
			console.log(`${capFirstLetter(commentType)} comment form invalid: Missing comment type or text`);
			valid = false;
		}

		if (!commentFormValue.category_id || !commentFormValue.status_id) {
			valid = false;
		}

		setFormValid(valid);
	};

	const addComment = async (e) => {
		if (!formValid) return;
		e.preventDefault();

		let body = commentFormValue;
		delete body.created;
		body.labels = labelsToString(selectedLabels);

		let attachment = null;

		if (uploadedFile) {
			attachment = await uploadAttachmentToBucket(uploadedFile);
			body.content.attachment = attachment;

			if (!attachment) {
				console.error('Attachment upload failed');
			}
		}

		body.content.attachment = attachment;
		body.status_id = 1;

		console.log('body', body);

		await commentAPI.makeRequest(
			`/${comm}/comments/${urlString}`,
			'POST',
			body,
			'new comment',
			undefined,
			undefined,
			undefined,
			undefined
		);

		await fetchingComments();
		setCommentFormValue(initialCommentFormValue);
		setSelectedLabels(null);
	};

	const handleUserUploadsAttachment = async (e) => {
		const file = e.target.files?.[0];
		if (!file) return;

		const attachment = {
			title: file.name,
			mimetype: file.type
		};

		setUploadedFile(file);
		setCommentFormValue((prev) => ({
			...prev,
			content: {
				...prev.content,
				attachment: attachment
			}
		}));
	};

	const uploadAttachmentToBucket = async (file) => {
		console.log('file', file);

		const presignResponse = await getPreSignedUrl.makeRequest(
			`/${comm}/comments/attachment`,
			'POST',
			{
				file_name: file.name,
				mime_type: file.type
			},
			''
		);

		console.log(presignResponse);

		if (!presignResponse?.upload_url || !presignResponse?.s3uri) return;

		const uploadResponse = await fetch(presignResponse?.upload_url, {
			method: 'PUT',
			headers: {
				'Content-Type': file.type
			},
			body: file
		});

		console.log(uploadResponse);

		if (!uploadResponse?.ok) {
			console.error('Attachment upload failed');
			return;
		}

		return {
			s3uri: presignResponse?.s3uri,
			title: file.name,
			mimetype: file.type
		};
	};

	const handleSetEditingComment = (commentId) => {
		if (!editingComment) {
			const thisComment = data.find((comm) => comm.id === commentId);

			console.log('thisComment', thisComment);

			if (!thisComment) return;
			setEditingComment(thisComment.id);
			setCommentFormValue({
				subject_id: currentCapture.site_id,
				content: {
					text: thisComment.content.text,
					attachment: thisComment.content.attachment
				},
				user_id: user,
				created: thisComment.created,
				status_id: thisComment.status_id,
				category_id: thisComment.category_id
			});
			setSelectedLabels(labelsToOptions(thisComment.labels));
		} else {
			setEditingComment(null);
			setCommentFormValue(initialCommentFormValue);
			setSelectedLabels(null);
		}
	};

	const handleEditingComment = async (commentId) => {
		if (!formValid) return;
		console.log(commentFormValue, commentId);

		let body = {
			user_id: user,
			content: commentFormValue.content,
			category_id: commentFormValue.category_id,
			labels: labelsToString(selectedLabels)
			//status_id: commentFormValue.status_id,
		};

		let attachment = null;

		if (uploadedFile) {
			attachment = await uploadAttachmentToBucket(uploadedFile);
			body.content.attachment = attachment;

			if (!attachment) {
				console.error('Attachment upload failed');
			}
		}

		console.log('body', body);

		await commentAPI.makeRequest(
			`/${comm}/comments/${urlString}/${commentId}`,
			'PATCH',
			body,
			'editing comment',
			undefined,
			undefined,
			undefined,
			undefined
		);

		setEditingComment(null);
		setCommentFormValue(initialCommentFormValue);
		setSelectedLabels(null);
		await fetchingComments();
	};

	const handleChangeCommentStatus = async (commentId, newStatusId) => {
		await changingCommentStatus(commentId, newStatusId);
		await fetchingComments();
	};

	const handleDeleteComment = async (commentId) => {
		await commentAPI.makeRequest(
			`/${comm}/comments/${urlString}/${commentId}`,
			'DELETE',
			{ user_id: user },
			'deleting comment',
			undefined,
			undefined,
			undefined,
			undefined
		);

		await fetchingComments();
	};

	const handleDownloadAttachment = async (attachment) => {
		console.log('attachment', attachment);
		try {
			const response = await fetch(attachment.url);
			console.log(response);

			if (!response.ok) {
				console.error('Failed to download attachment');
			}

			const blob = await response.blob();
			const url = window.URL.createObjectURL(blob);

			const link = document.createElement('a');
			link.href = url;
			link.download = attachment.title;

			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);

			window.URL.revokeObjectURL(url);
		} catch (error) {
			console.error('Error downloading attachment:', error);
		}
	};

	const handleCloseModal = () => {
		setEditingComment(null);
		setCommentFormValue(initialCommentFormValue);
		setSelectedLabels(null);
		setUploadedFile(null);
	};

	const renderLabelOptions = (labels) => {
		return (
			<CreatableSelect
				isMulti
				isClearable
				//isDisabled={editingComment !== row.id}
				value={selectedLabels}
				onChange={(selected) => {
					setSelectedLabels(selected || []);
				}}
				placeholder="Add labels..."
			/>
		);
	};

	const renderEditCommentRow = (comment) => {
		return (
			<>
				<tr key={comment.id}>
					<td>
						<input
							type="text"
							className="form-control"
							value={commentFormValue.subject_id}
							disabled
						></input>
					</td>
					<td>
						{' '}
						<input
							type="text"
							className="form-control"
							value={commentFormValue.created}
							disabled
						></input>
					</td>

					<td>
						<input
							type="text"
							className="form-control"
							value={commentFormValue.user_id}
							disabled
						></input>
					</td>

					<td>
						<select
							name="comment_category"
							id="comment_category"
							className="form-control"
							value={commentFormValue.category_id || ''}
							onChange={(e) =>
								setCommentFormValue((prev) => ({
									...prev,
									category_id: e.target.value
								}))
							}
						>
							<option value="">Choose a category</option>

							{endpointContextObj.dbData?.commentCategories?.map((cat) => (
								<option key={cat.id} value={cat.id}>
									{cat.name}
								</option>
							))}
						</select>
					</td>

					<td>
						<input
							type="text"
							className="form-control"
							value={commentFormValue.content.text}
							onChange={(e) =>
								setCommentFormValue((prev) => ({
									...prev,
									content: {
										...prev.content,
										text: e.target.value
									}
								}))
							}
						></input>
					</td>
					<td>{renderLabelOptions()}</td>

					<td>
						{
							endpointContextObj.dbData?.commentStatuses?.find(
								(cat) => cat.id === comment.status_id
							)?.name
						}
					</td>

					<td>
						{commentFormValue.content?.attachment?.url ? (
							<>
								<button
									type="button"
									className="noStyleButton mx-1 interactIcon"
									data-tooltip-id="delete-uploaded-file-TT"
									onClick={() =>
										setCommentFormValue((prev) => ({
											...prev,
											content: { ...prev.content, attachment: null }
										}))
									}
								>
									<i class="fa-solid fa-file-circle-xmark fa-lg"></i>
								</button>
								<Tooltip
									id="delete-uploaded-file-TT"
									place="top"
									effect="solid"
								>
									Delete uploaded file:
									<strong>
										{' '}
										{commentFormValue?.content?.attachment?.title}
									</strong>
								</Tooltip>
							</>
						) : (
							<>
								<input
									type="file"
									id="comment-file-upload"
									onChange={(e) => handleUserUploadsAttachment(e)}
									name="fileUploadComment"
									style={{ display: 'none' }}
								/>

								<button
									htmlFor="comment-file-upload"
									className="btn btn-sm my-0 py-0 interactIcon"
									id="comment-upload-attachment-button"
									data-tooltip-id="commentAPIsFileUpload"
								>
									<i className="fa-solid fa-file-arrow-up fa-xl interactIcon"></i>
								</button>
								<Tooltip id="commentAPIsFileUpload" place="top" effect="solid">
									Upload an attachment to support your comment
								</Tooltip>
							</>
						)}
					</td>

					<td>
						<button
							type="button"
							className="noStyleButton mx-2 interactIcon"
							data-tooltip-id="cancel-edits-TT"
							onClick={() => handleSetEditingComment(null)}
						>
							<i className="fa-solid fa-xmark fa-lg"></i>
						</button>
						<Tooltip id="cancel-edits-TT" place="top" effect="solid">
							Cancel changes
						</Tooltip>

						<button
							type="button"
							className="noStyleButton mx-1 interactIcon"
							data-tooltip-id={
								!formValid ? 'form-not-valid-TT' : 'save-changes-TT'
							}
							onClick={() => handleEditingComment(comment.id)}
							disabled={!formValid}
						>
							<i className="fa-solid fa-floppy-disk fa-lg"></i>
						</button>
						<Tooltip id="save-changes-TT" place="top" effect="solid">
							Save changes
						</Tooltip>

						<Tooltip id="form-not-valid-TT" place="top" effect="solid">
							The form is missing some fields
						</Tooltip>
					</td>
				</tr>
			</>
		);
	};

	const renderCurrentCommentsRows = (comment) => {
		return (
			<tr key={comment.id}>
				<td>{comment.subject_id}</td>
				<td>{formatDate(comment.created?.slice(0, 10))}</td>
				<td>{comment.user_id}</td>
				<td>
					{
						endpointContextObj.dbData?.commentCategories?.find(
							(cat) => cat.id === comment.category_id
						)?.name
					}
				</td>
				<td>{comment.content.text}</td>
				<td>{comment.labels}</td>

				<td>
					<select
						name="comment_status"
						id="comment_status"
						className="form-control"
						value={comment.status_id || ''}
						onChange={(e) =>
							handleChangeCommentStatus(comment.id, parseInt(e.target.value))
						}
						data-tooltip-id="change-comment-status-TT"
					>
						{endpointContextObj.dbData?.commentStatuses?.map((cat) => (
							<option key={cat.id} value={cat.id}>
								{cat.name}
							</option>
						))}
					</select>

					<Tooltip id={`change-comment-status-TT`} place="top" effect="solid">
						Change the status of this comment
					</Tooltip>
				</td>

				<td>
					{comment.content?.attachment?.s3uri && (
						<>
							<button
								type="button"
								className="noStyleButton mx-1 interactIcon"
								data-tooltip-id={`file-attachment-${comment.id}-TT`}
								onClick={() =>
									handleDownloadAttachment(comment.content.attachment)
								}
							>
								<i className="fa-solid fa-file fa-lg"></i>
							</button>

							<Tooltip
								id={`file-attachment-${comment.id}-TT`}
								place="top"
								effect="solid"
							>
								Click to download{' '}
								<strong>{comment.content.attachment.title}</strong>
							</Tooltip>
						</>
					)}
				</td>

				<td>
					{comment.user_id !== user ? (
						<>
							<button
								type="button"
								className="noStyleButton interactIcon  mx-1"
								data-tooltip-id={'not-user-edit-comment-TT'}
								disabled
							>
								<i
									className="fa-solid fa-pen fa-lg"
									style={{ color: 'lightgray' }}
								></i>
							</button>
							<Tooltip id="not-user-edit-comment-TT" place="top" effect="solid">
								You can only edit comments where you are the author
							</Tooltip>
						</>
					) : comment.content.text === '[deleted]' ? (
						<>
							<button
								type="button"
								className="noStyleButton mx-1 interactIcon"
								data-tooltip-id={'comment-deleted-edit-comment-TT'}
								disabled
							>
								<i
									className="fa-solid fa-pen fa-lg"
									style={{ color: 'lightgray' }}
								></i>
							</button>
							<Tooltip
								id="comment-deleted-edit-comment-TT"
								place="top"
								effect="solid"
							>
								You cannot edit deleted comments
							</Tooltip>
						</>
					) : (
						<>
							<button
								type="button"
								className="noStyleButton mx-1 interactIcon"
								onClick={() =>
									comment.user_id === user
										? handleSetEditingComment(comment.id)
										: undefined
								}
								data-tooltip-id={'edit-comment-TT'}
							>
								<i className="fa-solid fa-pen fa-lg"></i>
							</button>
							<Tooltip id="edit-comment-TT" place="top" effect="solid">
								Edit this comment
							</Tooltip>
						</>
					)}

					{comment.content.text === '[deleted]' ? (
						<>
							<button
								type="button"
								className="noStyleButton mx-1 interactIcon"
								data-tooltip-id="comment-already-deleted-delete-comment-TT"
								disabled
							>
								<i
									className="fa-solid fa-trash fa-lg"
									style={{ color: 'lightgray' }}
								></i>
							</button>
							<Tooltip
								id="comment-already-deleted-delete-comment-TT"
								place="top"
								effect="solid"
							>
								This comment has already been deleted
							</Tooltip>
						</>
					) : comment.user_id !== user ? (
						<button
							type="button"
							className="noStyleButton mx-1 interactIcon"
							data-tooltip-id="not-user-deleted-delete-comment-TT"
							disabled
						>
							<i
								className="fa-solid fa-trash fa-lg"
								style={{ color: 'lightgray' }}
							></i>
						</button>
					) : (
						<>
							<button
								type="button"
								className="noStyleButton mx-1 interactIcon"
								onClick={() =>
									comment.user_id === user
										? handleDeleteComment(comment.id)
										: undefined
								}
								data-tooltip-id="delete-comment-TT"
								disabled={comment.user_id !== user}
							>
								<i className="fa-solid fa-trash fa-lg"></i>
							</button>
							<Tooltip id="delete-comment-TT" place="top" effect="solid">
								Delete this comment
							</Tooltip>
						</>
					)}
				</td>
			</tr>
		);
	};

	const renderAddNewCommentRows = () => {
		return (
			<>
				<tr style={{ height: '50px' }}></tr>
				<tr style={{ marginTop: '50px', marginBottom: '10px' }}>
					<td colSpan={8} className="fw-bold fs-6">
						Add a new comment
					</td>
				</tr>
				<tr>
					<td>{commentType === 'captureSite' ? currentCapture?.id : currentCapture.site_id}</td>
					<td>
						<input
							type="text"
							className="form-control"
							value={commentFormValue.created}
							disabled
						></input>
					</td>
					<td>
						<input
							type="text"
							className="form-control"
							value={commentFormValue.user_id}
							disabled
						></input>
					</td>

					<td>
						<select
							name="comment_category"
							id="comment_category"
							className="form-control"
						>
							<option value="">Choose an option</option>

							{endpointContextObj.dbData?.commentCategories?.map((cat, idx) => (
								<option value={cat.id}>{cat.name}</option>
							))}
						</select>
					</td>

					<td>
						<input
							type="text"
							className="form-control"
							value={commentFormValue.content.text}
							onChange={(e) =>
								setCommentFormValue((prev) => ({
									...prev,
									content: { ...prev.content, text: e.target.value }
								}))
							}
						></input>
					</td>
					<td>{renderLabelOptions()}</td>

					<td>
						<input
							type="text"
							disabled
							value={'open'}
							className="form-control"
						/>
					</td>

					<td>
						{commentFormValue.content.attachment ? (
							<>
								<button
									type="button"
									className="noStyleButton mx-1 interactIcon"
									data-tooltip-id="delete-uploaded-file-TT"
									onClick={() =>
										setCommentFormValue((prev) => ({
											...prev,
											content: { ...prev.content, attachment: null }
										}))
									}
								>
									<i class="fa-solid fa-file-circle-xmark fa-lg"></i>
								</button>
								<Tooltip
									id="delete-uploaded-file-TT"
									place="top"
									effect="solid"
								>
									Delete uploaded file:
									<strong>
										{' '}
										{commentFormValue?.content?.attachment?.title}
									</strong>
								</Tooltip>
							</>
						) : (
							<>
								<input
									type="file"
									id="comment-file-upload"
									onChange={(e) => handleUserUploadsAttachment(e)}
									name="fileUploadComment"
									style={{ display: 'none' }}
								/>

								<button
									htmlFor="comment-file-upload"
									className="btn btn-sm my-0 py-0 interactIcon"
									id="comment-upload-attachment-button"
									data-tooltip-id="commentAPIsFileUpload"
								>
									<i className="fa-solid fa-file-arrow-up fa-xl interactIcon"></i>
								</button>
								<Tooltip id="commentAPIsFileUpload" place="top" effect="solid">
									Upload an attachment to support your comment
								</Tooltip>
							</>
						)}
					</td>

					<td>
						<button
							type="button"
							className="noStyleButton mx-1 interactIcon mt-1"
							data-tooltip-id={
								!formValid ? 'button-not-valid-TT' : 'save-new-comment-TT'
							}
							onClick={formValid ? (e) => addComment(e) : undefined}
						>
							<i className="fa-solid fa-floppy-disk fa-lg "></i>
						</button>
						<Tooltip id="save-new-comment-TT" place="top" effect="solid">
							Create new comment
						</Tooltip>
						<Tooltip id="button-not-valid-TT" place="top" effect="solid">
							There are missing fields in the form
						</Tooltip>
					</td>
				</tr>
			</>
		);
	};

	console.log('commentFormValue', commentFormValue)

	return (
		<div
			className="modal modal-sm fade"
			data-bs-backdrop="static"
			data-bs-keyboard="false"
			id={`view${capFirstLetter(commentType)}CommentsModal`} 
			tabindex="-1"
			aria-labelledby={`view${capFirstLetter(commentType)}CommentsModalLabel`}
			aria-hidden="true"
			style={{ marginTop: '100px', marginLeft: 'auto' }}
		>
			<div
				className="modal-dialog"
				style={{ width: '70vw', marginLeft: '20%' }}
			>
				<div className="modal-content" style={{ width: '70vw' }}>
					<div
						className="modal-header text-light"
						style={{ backgroundColor: 'rgb(48, 48, 48)' }}
					>
						<h5 className="modal-title" id={`view${capFirstLetter(commentType)}CommentsModalLabel`}>
							<i className="fa-solid fa-comments me-3"></i>{commentType === 'site' ? 'Site comments' : 'Capture comments for this site'}
						</h5>
					</div>

					<div
						class="modal-body"
						style={{ maxHeight: '550px', overflowY: 'auto' }}
					>
						<input
							id="show-deleted-comments-checkbox"
							type="checkbox"
							checked={showDeletedComments}
							onChange={() => setShowDeletedComments((prev) => !prev)}
							className="form-check-input"
						/>

						<label
							htmlFor="show-deleted-comments-checkbox"
							className="form-check-label"
						>
							Show deleted comments
						</label>

						<div className="table-responsive mt-4">
							<table
								className="table table-auto"
								style={{
									tableLayout: 'auto',
									width: 'auto'
								}}
							>
								<thead>
									<tr>
										<th style={{ width: '10%' }}>{capFirstLetter(commentType)} ID</th>
										<th style={{ width: '10%' }}>Date</th>
										<th style={{ width: '10%' }}>Raised by</th>
										<th>Category</th>
										<th style={{ width: '25%' }}>Comment</th>
										<th style={{ width: '20%' }}>Labels</th>
										<th style={{ width: '8%' }}>Status</th>
										<th style={{ width: '5%' }}>Files</th>
										<th style={{ width: '7%' }}>Actions</th>
									</tr>
								</thead>

								<tbody>
									{filteredComments?.map((comment) =>
										editingComment === comment.id
											? renderEditCommentRow(comment)
											: renderCurrentCommentsRows(comment)
									)}

									{!editingComment && <>{renderAddNewCommentRows()}</>}
								</tbody>
							</table>
						</div>
					</div>

					<div class="modal-footer">
						<>
							<button
								type="button"
								className="btn btn-secondary"
								data-bs-toggle="modal"
								data-bs-target={`#view${capFirstLetter(commentType)}CommentsModal`}
								onClick={() => handleCloseModal()}
								disabled={editingComment}
							>
								Close
							</button>
						</>
					</div>
				</div>
			</div>
		</div>
	);
};
